module.exports = __webpack_public_path__ + "img/StrategicPlanningIcon.ff385450.svg";